import { MediaContentTypes } from "constants/contentTypes";
import { CSSProperties } from "react";
import { HyperLinkBuilder } from "widgets/commonComponents/inline/hyperLink";
import { isHavakVisible, PayWallArctilceIcon } from "widgets/commonComponents/inline/payWallHavak/payWallHavak";
import { SlotIconDisplay } from "widgets/commonComponents/inline/slotIconDisplay/slotIconDisplay";
import { ComponentaIconType, IFieldDisplayData, LinkedItemType, VideoSettingsData } from "widgets/commonDataObjects/interfaces";
import { SiteImageData, SiteItemData, SiteMediaData } from "widgets/interfaces";
import { DateDisplay } from "../../../../commonComponents/inline/dateDisplay/dateDisplay";
import { MarketingSign } from "../../../../commonComponents/inline/marketingSign/marketingSign";
import { SiteMedia } from "../../../../siteWidgets/siteMedia";
import { secondsToHms } from "../../../../siteWidgets/siteWidgetUtils";
import { PodcastPlayer } from "../../../radioWidgets/floatingPlayer/podcastPlayerButton";
import { SiteSimpleImage } from "../../../../commonComponents/inline/siteSimpleImage";

interface MultiImagesFrontProps {
    imageWidth: number
    imageHeight: number
    item?: SiteItemData
    videoSettings?: VideoSettingsData
    fieldsDisplaySettings?: IFieldDisplayData
    margin?: number
    onRowDisplay: boolean
    titleColor: string
    isYplusComp?: boolean
    isSmallItem?: boolean
    isLTR: boolean
    isImageOnly: boolean
    includeAudioPlayer: boolean
    siteName?: string
    itemColor?: string
    shouldDisplayCategoryIcon?: boolean
    shouldRedirectToArticle?:boolean
}

export class MultiImagesItemFront extends React.Component<MultiImagesFrontProps>{

    private getIcon = (icon: ComponentaIconType, displayVideoIcon: boolean) => {
        if (icon === "automatic" && displayVideoIcon) return "video"
        return icon;
    }

    private getSlotViewStyle = () => {
        const { onRowDisplay, isLTR, margin, isImageOnly } = this.props;
        let marginStyle: CSSProperties = { margin: "0 10px 24px"};
        if (onRowDisplay) {
            if (!isLTR) {
                marginStyle = { margin: "unset", marginInlineEnd: margin }
            }
            else {
                marginStyle = { margin: "unset", marginInlineEnd: margin }
            }
        }
        if (isImageOnly) {
            marginStyle = { margin: "0 10px 10px" }
        }

        return marginStyle;
    }


    public render() {
        const { imageWidth, item, imageHeight, videoSettings, fieldsDisplaySettings, titleColor, isYplusComp, isSmallItem, isImageOnly, includeAudioPlayer, siteName, itemColor, shouldDisplayCategoryIcon, shouldRedirectToArticle } = this.props
        const { icon, audioArticleData, itemType, itemId, media, title, titleLink, titleTargetLink, author, categoryName, dateUpdatedOnSite, premiumExpireDays, isMarketingContent, marketingContentText, isCommertial, displayVideoIcon, subchannelName, redLabelText, textPlace, isYplusItem } = item
        let emptyMedia: SiteMediaData = { url: "", mediaType: MediaContentTypes.MEDIA_IMAGE, title: "", className: "", alt: "", ariaHidden: true } as SiteImageData
        const slotViewStyle = {...this.getSlotViewStyle(), backgroundColor: itemColor ?  itemColor : undefined};
        const titleStyle = { color: titleColor }
        const itemIcon = icon ? icon : "automatic";
        const showUpInfoArea = fieldsDisplaySettings.isChannelNameVisible
        const shouldDisplaySeparator = fieldsDisplaySettings.isAuthorVisible && itemType === LinkedItemType.ARTICLE && fieldsDisplaySettings.isDateVisible && author.length > 0;
        const shouldDisplayFirstSep = fieldsDisplaySettings.isCategoryVisible && includeAudioPlayer && fieldsDisplaySettings.isAuthorVisible && itemType === LinkedItemType.ARTICLE;
        const shouldDisplayDate = fieldsDisplaySettings.isDateVisible && itemType === LinkedItemType.ARTICLE;
        const isPlus = isHavakVisible({ premiumExpireDays: premiumExpireDays, dateUpdatedOnSite: dateUpdatedOnSite });
        const isAudioIconVisible = includeAudioPlayer && (icon === "audio" || icon === "automatic") && audioArticleData && audioArticleData.audioUrl && audioArticleData.durationSeconds;
        const itemLabel = `${categoryName} - ${title}`;
        const browserDisplayMediaMetaData = { title: title, artist: "ynet", album: categoryName }
        const alternatePresenterName = audioArticleData && audioArticleData.alternatePresenterName;
        const displayCategoryOrPresenterName = alternatePresenterName ? alternatePresenterName : categoryName;
        //    const author =   fieldsDisplaySettings.isCategoryVisible && (category || alternatePresenterName) && <span className="category">{displayCategoryOrPresenterName}</span>
        const isMoreDetails = fieldsDisplaySettings.isDateVisible || (fieldsDisplaySettings.isCategoryVisible && includeAudioPlayer) || fieldsDisplaySettings.isAuthorVisible;
        let rangeThumbColor = "";
        let rangeColor = "";
        let rangeProgressColor = "";

        switch (siteName) {
            case "magazine2025":
                rangeThumbColor = "#fff";
                rangeColor = "#ffffff6c";
                rangeProgressColor = "#fff";
                break;

            default: //default option is ynet player colors
                break;
        }

        return (
            <div className="slotView" style={slotViewStyle}>
                <div className="imageArea" data-tb-thumbnail=''>
                    <PayWallArctilceIcon
                        premiumExpireDays={premiumExpireDays}
                        dateUpdatedOnSite={dateUpdatedOnSite}
                        className={`onImage`}
                        dataTbPremium
                    />

                    <div className="MediaCarousel" style={{ width: imageWidth, height: imageHeight }} >
                        <SiteMedia
                            data={media !== undefined ? media : emptyMedia}
                            width={imageWidth}
                            height={imageHeight}
                            videoSettings={videoSettings}
                            itemLinkUrl={titleLink}
                            isImageLinkable={!isAudioIconVisible}
                            linkTarget={titleTargetLink !== undefined && titleTargetLink}
                        />

                        <SlotIconDisplay
                            itemId={itemId} icon={isAudioIconVisible ? "audio" : this.getIcon(itemIcon, displayVideoIcon)} iconClassName="medium"
                            isIconVisible={displayVideoIcon || itemIcon === "video" || itemIcon === "automatic" || itemIcon === "audio"}
                            duration={isAudioIconVisible && secondsToHms(audioArticleData.durationSeconds)}
                            durationShow={isAudioIconVisible}
                        />
                    </div>

                    {!isPlus && isMarketingContent &&
                        <MarketingSign isSmallItem={isSmallItem} marketingContentText={marketingContentText} />
                    }

                    {!isPlus && !isMarketingContent && redLabelText && redLabelText.length > 0 &&
                        <span className={`basicLabel labelText ${textPlace}`}>{redLabelText}</span>
                    }
                </div>

                {!isImageOnly &&
                    <div className="slotTextArea">
                        {showUpInfoArea &&
                            <div className="upInfoArea">
                                {fieldsDisplaySettings.isChannelNameVisible && subchannelName !== null && subchannelName}
                            </div>
                        }

                        {fieldsDisplaySettings.isTitleVisible &&
                            <div className={`slotTitle medium ${isCommertial ? "commertialTitle" : ""}`}>
                                <HyperLinkBuilder
                                    children={title}
                                    href={titleLink}
                                    isDataTbLink={true}
                                    linkTarget={titleTargetLink !== undefined && titleTargetLink}
                                >
                                    <div dangerouslySetInnerHTML={{ __html: title }} style={titleStyle} data-tb-title='' />
                                </HyperLinkBuilder>
                            </div>
                        }

                        {(!isYplusItem || !isYplusComp) && isMoreDetails &&
                            <div className="moreDetails">
                                {shouldDisplayCategoryIcon && item.categoryIcon!==null && <SiteSimpleImage src={item.categoryIcon} alt={item.categoryName} className="categoryIcon" /> }
                                {fieldsDisplaySettings.isCategoryVisible && includeAudioPlayer && (categoryName || alternatePresenterName) && <span className="authorField">{displayCategoryOrPresenterName}</span>}
                                {shouldDisplayFirstSep && <span className="separator">|</span>}
                                {fieldsDisplaySettings.isAuthorVisible && <span className="authorField" data-tb-author=''>{author}</span>}
                                {shouldDisplaySeparator && <span className="separator">|</span>}
                                {shouldDisplayDate && <DateDisplay date={dateUpdatedOnSite} isTbDate />}
                            </div>
                        }
                    </div>}

                {isAudioIconVisible &&
                    <PodcastPlayer
                        title={itemLabel}
                        isMobileWeb={false}
                        articleLink={titleLink}
                        rangeColor={rangeColor}
                        className="audio-play-button"
                        rangeThumbColor={rangeThumbColor}
                        audioUrl={audioArticleData.audioUrl}
                        rangeProgressColor={rangeProgressColor}
                        durationSeconds={audioArticleData.durationSeconds}
                        browserDisplayMediaMetaData={browserDisplayMediaMetaData}
                        shouldRedirectToArticle={shouldRedirectToArticle}
                        articleData={{ ...item, articleId: itemId, specialData: { audioData: audioArticleData }, publishedLink: titleLink }}
                    />
                }
            </div>
        )
    }
}